import ProductPageLayout from "@/components/ProductPageLayout";
import verhokiskot from "@/assets/verhokiskot.png?format=webp&w=800";

const CurtainTrackInstallation = () => (
  <ProductPageLayout title="Curtain track installation" metaDescription="Curtain track installation in Central Uusimaa. Track and rod systems professionally installed." image={verhokiskot} partner="osio" path="/en/curtain-track-installation" alternatePath="/verhokisko-asennus">
    <p className="text-muted-foreground leading-relaxed">
      A quality curtain track is the foundation of any curtain setup. We provide comprehensive installation services for track 
      and rod systems – ceiling or wall mounted, single and multi-track solutions.
    </p>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Curtain track types</h2>
    <ul className="space-y-2 text-muted-foreground">
      <li>✓ Ceiling tracks – clean and modern look</li>
      <li>✓ Wall-mounted tracks and rods</li>
      <li>✓ Motorized curtain tracks</li>
      <li>✓ Curved tracks for special installations</li>
    </ul>
    <p className="text-muted-foreground mt-6 leading-relaxed">
      We install curtain tracks in Hyvinkää, Järvenpää, Kerava, Mäntsälä, Nurmijärvi, Pornainen and Tuusula. 
      See <a href="https://osio.fi" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 text-foreground">Osio curtain tracks</a>.
    </p>
  </ProductPageLayout>
);

export default CurtainTrackInstallation;
